import React, { useEffect, useState } from "react";
import axiosInstance from "../../../axios/axios";
import { END_POINTS } from "../../../shared";
import { useTheme } from "@mui/material/styles";

// Import dark mode icons
import myscan_palo_dark from '../../../assets/myscan_palo_dark.svg';
import myscan_arista_dark from '../../../assets/myscan_arista_dark.svg';
import myscan_cisco_dark from '../../../assets/myscan_cisco_dark.svg';
import myscan_juniper_dark from '../../../assets/myscan_juniper_dark.svg';
import fortinet_scan_dark from '../../../assets/fortinet_scan_dark.svg';
import myscan_sophos_dark from '../../../assets/myscan_sophos_dark.svg';
import debian_dark from '../../../assets/debian_dark.svg';
import debian_light from "../../../assets/baseVersion/debian_light.svg";
import windows_dark from "../../../assets/baseVersion/Windows_dark.svg";
import Windows_light from "../../../assets/baseVersion/Windows_light.svg"
import ubuntu_dark from "../../../assets/ubuntu_dark.svg";
import ubuntu_light from "../../../assets/ubuntu_white.svg";
import redhat_light from "../../../assets/redhat_light.svg";
import redhat_dark from "../../../assets/redhat_dark.svg";
import redhat_transparent from "../../../assets/baseVersion/redhat-transparentt.png";
import huawei_dark from "../../../assets/huawei-dark.svg";
import huawei_light from "../../../assets/huawei-ar21 1.svg";
import mikrotik from "../../../assets/mikrotik.svg";
import mikrotik_dark from "../../../assets/mikrotik_dark.svg";
import edgecore_logo from "../../../assets/baseVersion/edgecore-logo.svg";
import tplink_light from "../../../assets/baseVersion/TPLINK_Logo_2 1.svg";
import tplink_dark from "../../../assets/baseVersion/TPLINK_Logo_dark.svg";
import dell_logo from "../../../assets/baseVersion/dell-seeklogo 2.svg";

import syrotech_light from "../../../assets/syrotech_light.svg";
import syrotech_dark from "../../../assets/syrotech_dark.svg";
import { Microsoft } from "@mui/icons-material";



// Mapping for dark mode icons
const darkIcons: Record<string, string> = {
    paloalto: myscan_palo_dark,
    arista: myscan_arista_dark,
    cisco: myscan_cisco_dark,
    juniper: myscan_juniper_dark,
    fortinet: fortinet_scan_dark,
    sophos: myscan_sophos_dark,
    "palo alto": myscan_palo_dark,
    debian: debian_dark,
    ubuntu: ubuntu_dark,
    microsoft: windows_dark,
    redhat: redhat_dark,
    huawei: huawei_dark,
    mikrotik: mikrotik_dark,
    edgecore: edgecore_logo,
    "tp-link": tplink_dark,
    tplink: tplink_dark,
    dell: dell_logo,
    syrotech: syrotech_dark,
    // fortinet:myscan_fortinet_dark
};

interface VendorsProps {
    onSelectVendor: (vendorName: string) => void;
    onLoadVendors: (vendors: any[]) => void; // New callback prop
}

interface VendorCategory {
    id: string;
    name: string;
}

interface Vendor {
    id: string;
    name: string;
    categories: VendorCategory[];
}

const Vendors: React.FC<VendorsProps> = ({ onSelectVendor, onLoadVendors }) => {
    const [vendors, setVendors] = useState<Vendor[]>([]);
    const [error, setError] = useState(null);
    const theme = useTheme();

    const getImagePath = (name: string) => {
        console.log(name);
        console.log("sadfdsfdsf")
        //const fileName = isDarkMode ? `${name.toLowerCase()}_dark` : name.toLowerCase();
        console.log(name);

        return new URL(`../../../assets/${name.toLowerCase()}.svg`, import.meta.url).href;
    };
    //const getImagePath = (name: string) => new URL(`../../../assets/${name.toLowerCase()}.svg`, import.meta.url).href;
    const getWhiteImagePath = (name: string) => new URL(`../../../assets/${name.toLowerCase()}-white.svg`, import.meta.url).href;

    useEffect(() => {
        const fetchVendors = async () => {
            try {
                const res = await axiosInstance.get(END_POINTS.VENDORS);
                //here set vendors
                console.log(res.data.data.vendors, 'vendors');
                setVendors(res.data.data.vendors);
                onLoadVendors(res.data.data.vendors);
                // For testing without backend, uncomment below and comment above two lines
                // setVendors([
                //     {
                //         "id": "99d85163-44d3-4c3e-8678-3f29845a0095",
                //         "name": "Paloalto",
                //         "categories": [
                //             { "id": "a8013453-6693-4ef5-8795-031339c24c4b", "name": "PANOS" }
                //         ]
                //     },
                //     {
                //         "id": "967d309b-9c26-4c33-b753-0183c8858d6b",
                //         "name": "Arista",
                //         "categories": [
                //             { "id": "16bc7ab3-3dd0-4c96-87d3-ae8490edbbcc", "name": "EOS" }
                //         ]
                //     },
                //     {
                //         "id": "8446f050-af94-405c-a9bc-7bb74e142175",
                //         "name": "Cisco",
                //         "categories": [
                //             { "id": "a3bb83cf-7d06-4723-b2fa-d48e054f9c5c", "name": "ASA" },
                //             { "id": "1c16a31f-7206-4742-a7a9-617ddb5a7c6e", "name": "IOS" },
                //             { "id": "5516834c-8bac-4f6c-a32a-b75f57065df5", "name": "WLC" },
                //             { "id": "5571126b-07d7-452c-acea-ec4fcdf75ac9", "name": "SMALL BUSINESS" },
                //             { "id": "e05501e0-a014-4a63-ac4d-0f139a9b57e5", "name": "IOS XE" },
                //             { "id": "95fd663c-0533-4455-bdbf-183cc0f56a03", "name": "S200" }
                //         ]
                //     },
                //     {
                //         "id": "e13f557f-d333-456a-b051-d9324fb7b10e",
                //         "name": "Fortinet",
                //         "categories": [
                //             { "id": "b8e71bb4-69fc-4b3d-b8ff-10861247f507", "name": "FORTIGATE" }
                //         ]
                //     },
                //     {
                //         "id": "5ef3fa60-3a3e-4a43-9f0b-42d73f3cded3",
                //         "name": "Juniper",
                //         "categories": [
                //             { "id": "f1ec2157-c737-4c89-a50f-078de3578d94", "name": "JUNOS" }
                //         ]
                //     },
                //     {
                //         "id": "2b024bb5-e086-4f2b-afb4-134e7d44c18c",
                //         "name": "sophos",
                //         "categories": [
                //             { "id": "12345", "name": "Sophos" }
                //         ]
                //     }
                // ]);
                // onLoadVendors([
                //     {
                //         "id": "99d85163-44d3-4c3e-8678-3f29845a0095",
                //         "name": "Paloalto",
                //         "categories": [
                //             { "id": "a8013453-6693-4ef5-8795-031339c24c4b", "name": "PANOS" }
                //         ]
                //     },
                //     {
                //         "id": "967d309b-9c26-4c33-b753-0183c8858d6b",
                //         "name": "Arista",
                //         "categories": [
                //             { "id": "16bc7ab3-3dd0-4c96-87d3-ae8490edbbcc", "name": "EOS" }
                //         ]
                //     },
                //     {
                //         "id": "8446f050-af94-405c-a9bc-7bb74e142175",
                //         "name": "Cisco",
                //         "categories": [
                //             { "id": "a3bb83cf-7d06-4723-b2fa-d48e054f9c5c", "name": "ASA" },
                //             { "id": "1c16a31f-7206-4742-a7a9-617ddb5a7c6e", "name": "IOS" },
                //             { "id": "5516834c-8bac-4f6c-a32a-b75f57065df5", "name": "WLC" },
                //             { "id": "5571126b-07d7-452c-acea-ec4fcdf75ac9", "name": "SMALL BUSINESS" },
                //             { "id": "e05501e0-a014-4a63-ac4d-0f139a9b57e5", "name": "IOS XE" },
                //             { "id": "95fd663c-0533-4455-bdbf-183cc0f56a03", "name": "S200" }
                //         ]
                //     },
                //     {
                //         "id": "e13f557f-d333-456a-b051-d9324fb7b10e",
                //         "name": "Fortinet",
                //         "categories": [
                //             { "id": "b8e71bb4-69fc-4b3d-b8ff-10861247f507", "name": "FORTIGATE" }
                //         ]
                //     },
                //     {
                //         "id": "5ef3fa60-3a3e-4a43-9f0b-42d73f3cded3",
                //         "name": "Juniper",
                //         "categories": [
                //             { "id": "f1ec2157-c737-4c89-a50f-078de3578d94", "name": "JUNOS" }
                //         ]
                //     },
                //     {
                //         "id": "2b024bb5-e086-4f2b-afb4-134e7d44c18c",
                //         "name": "sophos",
                //         "categories": [
                //             { "id": "12345", "name": "Sophos" }
                //         ]
                //     }
                // ]);
            } catch (err) {
                //setError("Failed to load vendors");
            }
        };
        fetchVendors();
    }, []);

    return (
        <div className="devicescan-list">
            {vendors.length > 0 ? (
                vendors.map((vendor: any) => (
                    <div
                        key={vendor.id}
                        className={`devicescan-item ${theme.palette.mode === 'dark' ? 'dark-mode-item' : ''}`}
                        onClick={() => onSelectVendor(vendor)} // Trigger vendor selection
                        style={{ cursor: "pointer" }}
                    >
                        <div className="white-box">
                            {/* Conditionally render images based on theme mode */}
                            {theme.palette.mode === "dark" ? (
                                <div>
                                    <img src={darkIcons[vendor.name.toLowerCase()] || getImagePath(vendor.name)} alt={vendor.name} className="normal-state" />
                                    <img
                                        src={
                                            vendor.name.toLowerCase() === "debian"
                                                ? debian_dark
                                                : vendor.name.toLowerCase() === "ubuntu"
                                                    ? ubuntu_dark
                                                    : vendor.name.toLowerCase() === "microsoft"
                                                        ? windows_dark
                                                        : vendor.name.toLowerCase() === "redhat"
                                                            ? redhat_dark
                                                            : vendor.name.toLowerCase() === "huawei"
                                                                ? huawei_dark
                                                                : vendor.name.toLowerCase() === "mikrotik"
                                                                ? mikrotik_dark
                                                                : vendor.name.toLowerCase() === "edgecore"
                                                                ? edgecore_logo
                                                                 : vendor.name.toLowerCase() === "tp-link" || vendor.name.toLowerCase() === "tplink"
                                                                 ? tplink_dark
                                                                 : vendor.name.toLowerCase() === "dell"
                                                                 ? dell_logo
                                                                 : vendor.name.toLowerCase() === "syrotech"
                                                                 ? syrotech_dark
                                                                 : getWhiteImagePath(vendor.name)
                                        }
                                        alt={vendor.name}
                                        className="hover-state"
                                    />
                                </div>
                            ) : (
                                <>
                                    <img
                                        src={
                                            vendor.name.toLowerCase() === "debian"
                                                ? debian_light
                                                : vendor.name.toLowerCase() === "ubuntu"
                                                    ? ubuntu_light
                                                    : vendor.name.toLowerCase() === "redhat"
                                                        ? redhat_light
                                                        : vendor.name.toLowerCase() === "microsoft"
                                                            ? Windows_light
                                                            : vendor.name.toLowerCase() === "huawei"
                                                                ? huawei_light
                                                                : vendor.name.toLowerCase() === "mikrotik"
                                                                ? mikrotik
                                                                : vendor.name.toLowerCase() === "edgecore"
                                                                ? edgecore_logo
                                                                : vendor.name.toLowerCase() === "tp-link" || vendor.name.toLowerCase() === "tplink"
                                                                ? tplink_light
                                                                : vendor.name.toLowerCase() === "dell"
                                                                ? dell_logo
                                                                : vendor.name.toLowerCase() === "syrotech"
                                                                ? syrotech_light
                                                                : getImagePath(vendor.name)
                                        }
                                        alt={vendor.name}
                                        className="normal-state"
                                    />
                                    <img
                                        src={
                                            vendor.name.toLowerCase() === "debian"
                                                ? debian_dark
                                                : vendor.name.toLowerCase() === "ubuntu"
                                                    ? ubuntu_dark
                                                    : vendor.name.toLowerCase() === "microsoft"
                                                        ? windows_dark
                                                        : vendor.name.toLowerCase() === "redhat"
                                                            ? redhat_dark
                                                            : vendor.name.toLowerCase() === "huawei"
                                                                ? huawei_dark
                                                                : vendor.name.toLowerCase() === "mikrotik"
                                                                ? mikrotik_dark
                                                                : vendor.name.toLowerCase() === "edgecore"
                                                                ? edgecore_logo
                                                                : vendor.name.toLowerCase() === "tp-link" || vendor.name.toLowerCase() === "tplink"
                                                                ? tplink_dark
                                                                : vendor.name.toLowerCase() === "dell"
                                                                ? dell_logo
                                                                : vendor.name.toLowerCase() === "syrotech"
                                                                ? syrotech_dark
                                                                : getWhiteImagePath(vendor.name)
                                        }
                                        alt={vendor.name}
                                        className="hover-state"
                                    />
                                </>
                            )}
                        </div>
                    </div>
                ))
            ) : (
                <p>{error || "Loading vendors..."}</p>
            )}
        </div>
    );
};

export default Vendors;
